import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core";
import navigateHolderStyle from "./style/navigateStyle.js";
import { useLocation, useNavigate } from "@reach/router";

const useStyles = makeStyles(navigateHolderStyle);

export default function Navigate() {
  const path = useLocation();
  const classes = useStyles();
  let navigate = useNavigate();

  return (
    <div className={classes.navigateContainer}>
      <ul className={classes.ulNavigate}>
        <li
          className={
            path.pathname === "/creator/account"
              ? classes.liNavigateActive
              : classes.liNavigate
          }
          onClick={() => navigate("/creator/account")}
        >
          Account
        </li>
        <li
          className={
            path.pathname === "/creator/mint"
              ? classes.liNavigateActive
              : classes.liNavigate
          }
          onClick={() => navigate("/creator/mint")}
        >
          Mint Ampersand
        </li>
        <li
          className={
            path.pathname === "/creator/totalValue"
              ? classes.liNavigateActive
              : classes.liNavigate
          }
          // onClick={() => navigate('/creator/totalValue')}
        >
          Total Value Asset
        </li>
        <li
          className={
            path.pathname === "/creator/portFolio"
              ? classes.liNavigateActive
              : classes.liNavigate
          }
          // onClick={() => navigate('/creator/portFolio')}
        >
          Portfolio
        </li>
      </ul>
    </div>
  );
}
